// Module
var code = "<h3 id=\"词汇表\">词汇表</h3> <p><a href=\"index.md\">返回索引页</a></p> ";
// Exports
export default code;